import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import EsmsCard from '../../components/EsmsCard';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './RolesCard.module.css';

class RolesCard extends Component {

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin/roles' + history.location.search);
    }

    render() {
        let { currentUser, companyInfo, currentScopes } = this.props;

        return (
            <EsmsCard
                title="Roles"
                imagePath="/assets/images/rolesFlat.svg"
            >
                <div className={classes.innerContainer}>
                    <div className={classes.rolesInfo}>
                        <p>
                            <span className={classes.label}>Current Role</span>
                            <span className={classes.values}>
                                {currentUser.role.name}
                            </span>
                        </p>
                        <p>
                            <span className={classes.label}>Total Roles</span>
                            <span className={classes.values}>
                                {companyInfo.roles.length}
                            </span>
                        </p>
                    </div>
                    {
                        isAllowed(currentScopes, Permissions('adminFull')) &&
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePageRoute}
                        >
                            Manage Roles
                        </Button>
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        currentUser:   state.currentUser
    };
};

export default withRouter(connect(mapStateToProps)(RolesCard));

